import React from 'react';
import type { Block } from '../../types/parcours';
import RichTextBlock from './blocks/RichTextBlock';
import ImageBlock from './blocks/ImageBlock';
import VideoBlock from './blocks/VideoBlock';
import EmbedIframeBlock from './blocks/EmbedIframeBlock';
import PdfBlock from './blocks/PdfBlock';
import StatsGridBlock from './blocks/StatsGridBlock';
import TableBlock from './blocks/TableBlock';
import TimelineBlock from './blocks/TimelineBlock';
import TeamOrgBlock from './blocks/TeamOrgBlock';
import AVousDeJouerBlock from './blocks/AVousDeJouerBlock';

interface Props {
  blocks: Block[];
}

export default function BlocksRenderer({ blocks }: Props) {
  if (!Array.isArray(blocks) || blocks.length === 0) return null;

  return (
    <div className="space-y-2">
      {blocks.map((block, idx) => {
        const key = `block-${idx}-${block.type}`;

        switch (block.type) {
          case 'rich-text':
            return <RichTextBlock key={key} block={block as any} />;
          case 'image':
            return <ImageBlock key={key} block={block as any} />;
          case 'video':
            return <VideoBlock key={key} block={block as any} />;
          case 'embed-iframe':
            return <EmbedIframeBlock key={key} block={block as any} />;
          case 'pdf':
            return <PdfBlock key={key} block={block as any} />;
          case 'stats-grid':
          case 'stats':
          case 'stats_grid':
            return <StatsGridBlock key={key} block={block as any} />;
          case 'table':
            return <TableBlock key={key} block={block as any} />;
          case 'timeline':
            return <TimelineBlock key={key} block={block as any} />;
          case 'team-org':
          case 'team_org':
            return <TeamOrgBlock key={key} block={block as any} />;
          case 'a-vous-de-jouer':
            return <AVousDeJouerBlock key={key} />;
          default:
            if (import.meta.env.DEV) {
              return (
                <div key={key} className="rounded border border-dashed border-amber-300 bg-amber-50 px-4 py-2 text-xs text-amber-700">
                  Bloc inconnu : <code>{String(block.type)}</code>
                </div>
              );
            }
            return null;
        }
      })}
    </div>
  );
}
